import { DEFAULT_ICON_SIZE } from '../const';
import { IconProps } from '../types';

export const UserXIcon = ({ size = DEFAULT_ICON_SIZE }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M16 19a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4" />
      <circle cx="9" cy="7" r="4" />
      <path d="M17 10l5 5" />
      <path d="M22 10l-5 5" />
    </svg>
  );
};

